import { RootState } from '@reducers';

export const selectHealthQuoteDetailsPage = (state: RootState) => state.healthQuoteDetailsRouteReducer;
